module.exports = __webpack_public_path__ + "Server-Default.OfflineDrop.717f0f08d4eabf24e1287f6a6a5b0c87.hashedasset.svg";